// eslint-disable-next-line
export const addFootbar = footbar => ({ type: 'ADD_ACTION_BAR', payload: footbar });
